import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: -80,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

store.subscribe((mutation, state) => {
  if (mutation.type === 'LOAD_SCRIPT') {
    localStorage.setItem('history', JSON.stringify(state.history))
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
